module.exports = __webpack_public_path__ + "static/media/icon-close-grey.d6e7861d.svg";